export const Logo = ({ light = false, className = "" }) => (
  <div className={`inline-flex items-center gap-2.5 bg-white rounded-xl pl-2 pr-4 py-2 shadow-[0_6px_20px_-6px_rgba(11,25,44,0.35)] border border-slate-100 ${className}`} data-testid="hemozy-logo">
    <div className="w-8 h-8 shrink-0 rounded-lg bg-[#0B192C] flex items-center justify-center overflow-hidden">
      <svg viewBox="0 0 40 40" className="w-7 h-7">
        <path d="M20 6 C14 14, 9 18.5, 9 24 a11 11 0 0 0 22 0 C31 18.5, 26 14, 20 6 Z" fill="#D92638" />
        <path d="M11 26 a9 9 0 0 0 18 0 Z" fill="#0D9488" opacity="0.9" />
        <path d="M4 24 L12 24 L15 17 L19 31 L23 22 L26 25 L36 25" stroke="#fff" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
    <span className="font-extrabold text-xl tracking-tight text-[#0B192C] leading-none" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      Hemozy
    </span>
  </div>
);
